<template>
    <div class="biz-financial-report">
        <div class="biz-financial-report-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    }
}
</script>
<style lang="scss">
    .biz-financial-report{
        position: relative;
        .biz-financial-report-wrap{
            padding: 0 30px 30px 30px;
            width:  calc(1180px - 40px);
        }
    }
    @media screen and (max-width: 1280px){
        // .biz-bill-mgt{
        //     .biz-bill-mgt-wrap{
        //         padding: 30px;
        //     }
        // }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/financialReport/financialReportFrame.vue